export const CONTRACT_EXPIRED_STATUS = 'Contract Expired'

export function resolveContractStatus(
    status: string,
    hasExpiredContract: boolean,
    flagEnabled: boolean | undefined,
): string {
    if (hasExpiredContract && flagEnabled) {
        return CONTRACT_EXPIRED_STATUS
    }

    return status
}
